import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject, of } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { IConfig } from '../app/models/config';

@Injectable()
export class AppService {

    private globalConfig = '../assets/jsons/config.json';

    private appConfig: IConfig;
    private appConfigLoaded: BehaviorSubject<boolean> = new BehaviorSubject(false);    
    private hasLoaded = false;

    constructor(private http: HttpClient) {
        this.http.get<IConfig>(this.globalConfig).subscribe(
            _config => {
                this.appConfig = _config;
                this.appConfigLoaded.next(true);
            }
        )
    }

    getConfigStatus(): Observable<boolean> {
        return this.appConfigLoaded.asObservable()
    }

    getGlobalConfig(): IConfig {
        return this.appConfig;
    }     

    loadConfig(): Observable<void> {
        return this.http.get<IConfig>(this.globalConfig).pipe(
            tap(_config => {
                this.appConfig = _config;
                this.appConfigLoaded.next(true);
            }),
            catchError(error => {
                console.error('Error loading config:', error);
                this.appConfigLoaded.next(false);
                return of(null);
            })
        );
    }

    loadOneTrustScript(): void {
        if (this.hasLoaded) return;
        this.hasLoaded = true;

        const head = document.head;
        const firstHeadChild = head.firstChild;

        // Create OneTrust script
        const oneTrustScript = document.createElement('script');
        oneTrustScript.type = 'text/javascript';
        oneTrustScript.setAttribute('data-document-language', 'true');
        oneTrustScript.setAttribute('data-domain-script', this.appConfig.oneTrustScriptId);
        oneTrustScript.src = this.appConfig.oneTrustScriptUrl;

        oneTrustScript.onload = () => {
            const optanonWrapper = document.createElement('script');
            optanonWrapper.type = 'text/javascript';
            optanonWrapper.textContent = 'function OptanonWrapper() {}';
            head.insertBefore(optanonWrapper, oneTrustScript);
        };

        head.insertBefore(oneTrustScript, firstHeadChild);
    }
}
